// extracted by mini-css-extract-plugin
export var closeButton = "_36-3";
export var header = "_36-0";
export var link = "_36-1";
export var retryButton = "_36-2";